import { useRouterState } from "@tanstack/react-router";
import { detectLocale, toEnPath } from "./routeMap";

/**
 * Returnerar en helper som översätter en SV-länk till motsvarande EN-länk
 * när användaren är på en /en/*-sida. Behåller hash/query.
 *
 * Använd för chrome (header/footer/menyer) och delade CTA:er som annars
 * hade hårdkodat svenska URL:er på engelska sidor.
 */
export function useLocalizedHref() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isEn = detectLocale(pathname) === "en";
  return (svPath: string): string => {
    if (!isEn) return svPath;
    const hashIdx = svPath.indexOf("#");
    const queryIdx = svPath.indexOf("?");
    const splitAt =
      hashIdx === -1 && queryIdx === -1
        ? svPath.length
        : Math.min(
            hashIdx === -1 ? svPath.length : hashIdx,
            queryIdx === -1 ? svPath.length : queryIdx,
          );
    const base = svPath.slice(0, splitAt);
    const tail = svPath.slice(splitAt);
    return toEnPath(base) + tail;
  };
}
